import { Gender, IdentityDocumentType, NewsletterSubscription, } from '@massilia/prisma-generated/enums';
import { z } from 'zod';
import { personName } from '../_shared/person-name.js';
export const reservationFidelityCardSchema = z.object({
    companyId: z.string(),
    id: z.string().optional(),
    cardNumber: z.string(),
});
export const reservationIdentityDocumentSchema = z.object({
    id: z.string().optional(),
    documentNumber: z.string(),
    expiryDate: z.string(),
    issuingCountry: z.string(),
    type: z.nativeEnum(IdentityDocumentType),
});
export const reservationPassengerSchema = z.object({
    firstName: personName(),
    lastName: personName(),
    passengerId: z.string(),
    birthDate: z.string(),
    fidelityCards: z.array(reservationFidelityCardSchema).optional(),
    gender: z.nativeEnum(Gender),
    identityDocuments: z.array(reservationIdentityDocumentSchema).optional(),
    nationality: z.string(),
});
export const createReservationSchema = z.object({
    flightEstimateResponseId: z.string().optional(),
    tourismEstimateResponseId: z.string().optional(),
    animalInformation: z.string(),
    complementaryInformation: z.string(),
    newsletterSubscription: z.nativeEnum(NewsletterSubscription),
    otherContactPhone: z.string().optional(),
    // Legacy `@IsEmail @IsOptional @ValidateIf(o => o.otherEmailAddress !== '')`:
    // an empty string is allowed (skips the email check), otherwise must be an email.
    otherEmailAddress: z.union([z.literal(''), z.string().email()]).optional(),
    passengers: z.array(reservationPassengerSchema).min(1),
    seatInformation: z.string(),
    wantsCarLoan: z.boolean(),
    wantsInsurance: z.boolean(),
    wantsInvoice: z.boolean(),
});
/** Corps de `PATCH /reservation/:id/is-treated` (case « traité » du backoffice). */
export const updateReservationIsTreatedSchema = z.object({
    isTreated: z.boolean(),
});
